import { io } from "socket.io-client";

// ✅ Backend URL (future proof)
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

// ✅ SINGLETON SOCKET (important - multiple connections avoid karega)
let socket;

export const getSocket = () => {
  if (!socket) {
    socket = io(SOCKET_URL, {
      transports: ["websocket"],

      // ✅ auto reconnect
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,

      // ✅ optional but useful
      autoConnect: true,
      withCredentials: true,
    });

    // ✅ DEBUG LOGS (bahut useful)
    socket.on("connect", () => {
      console.log("✅ Socket connected:", socket.id);
    });

    socket.on("disconnect", () => {
      console.log("❌ Socket disconnected");
    });

    socket.on("connect_error", (err) => {
      console.error("⚠️ Socket error:", err.message);
    });
  }

  return socket;
};

// ✅ export default (easy use)
export default getSocket();
